import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-wrapper" }
const _hoisted_2 = { class: "info-content" }
const _hoisted_3 = { class: "loan-options-wrapper" }

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Step from "@/components/shared/Step.vue";
import RefiProgramLoanOption from "@/components/refi-loan-configuration/RefiProgramLoanOption.vue";
import { RefiRatePlanViewModel } from "@/models/refi";


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiProgramLoanOptions',
  emits: ["tileClicked"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emit = __emit;

const loanConfiguration = computed(() => store.state.appData.application.loanConfiguration);
const indexTypeName = computed(() => store?.state?.lenderData?.indexTypeName);
const selectedRateTerm = computed(() => store.state.refiLoanConfigurationModule.selectedRateTerm);
const availableRatePlans = computed(
  () => store.getters["refiLoanConfigurationModule/AvailableRatePlans"],
);
const terms = computed(() => getRepaymentTerms());
const formattedTerms = computed(() => {
  if (terms.value.length === 1) {
    return terms.value
      ?.map((n: any) => {
        return `${n}-year term`;
      })
      .join(" ");
  }

  if (terms.value.length === 2) {
    return terms.value
      ?.map((n: any, index: any) => {
        return index === terms.value.length - 1 ? `or ${n}-year terms` : `${n}-year`;
      })
      .join(" ");
  }

  return terms.value?.map((n: any, index: any) => {
    return index === terms.value.length - 1 ? `or ${n}-year terms` : `${n}-year,`;
  }).join(" ");
});

const promoDisclaimerText = computed(
  () => store.state.refiLoanConfigurationModule.programPromoDisclaimerText,
);

function getRepaymentTerms() {
  const availableTerms = availableRatePlans.value?.map((ratePlan: RefiRatePlanViewModel) => {
    return ratePlan.year;
  });
  return availableTerms?.sort((a: any, b: any) => a - b) || [];
}

async function setPreviouslySelectedRatePlanId() {
  // verify that the rate plans are populated
  if (availableRatePlans.value?.length === 0) {
    await store.dispatch("refiLoanConfigurationModule/getRefiRatePlans");
  }

  // Check if loan config has been set
  if (loanConfiguration.value && loanConfiguration.value?.ratePlanId) {
    store.dispatch(
      "refiLoanConfigurationModule/setSelectedRatePlanId",
      loanConfiguration.value?.ratePlanId,
    );
  }
}

onMounted(() => {
  setPreviouslySelectedRatePlanId();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Your Rate & Term Options", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("span", null, _toDisplayString(promoDisclaimerText.value), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _createTextVNode(" Below are your options for rates with " + _toDisplayString(formattedTerms.value) + ". ", 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "bold underline" }, "Please select one.", -1))
      ]),
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-header italic" }, "What's the difference between a fixed and variable rate?", -1)),
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(" A fixed rate means that your interest rate will be the same for the life of your loan. A variable rate will fluctuate over time based on the current " + _toDisplayString(indexTypeName.value) + " index rate. A variable interest rate will be the index percent plus a margin percent, which is set based on your credit score. ", 1),
          _cache[3] || (_cache[3] = _createElementVNode("a", {
            class: "link",
            href: "https://www.studentchoice.org/faq-items/what-is-the-difference-between-a-fixed-and-variable-rate/",
            target: "_blank"
          }, "Click here", -1)),
          _cache[4] || (_cache[4] = _createTextVNode(" to read more. ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRatePlans.value, (ratePlan) => {
          return (_openBlock(), _createBlock(RefiProgramLoanOption, {
            key: ratePlan,
            "rate-plan-option": ratePlan,
            term: ratePlan.year,
            class: _normalizeClass({ active: selectedRateTerm.value === ratePlan?.year })
          }, null, 8, ["rate-plan-option", "term", "class"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})